import angular from "angular";

angular
    .module('app')
    .component('clientsControl', {
        template: require('./clients-control.html'),
        controller: ['$http', '$uibModal', 'notifier', controller],
        bindings: {
            organization: '<',
            selectedFields: '<',
        }
    });

function controller($http, $uibModal, notifier) {

    const $ctrl = this;

    $ctrl.clients = [];

    $ctrl.total = null;

    $ctrl.page = 1;

    $ctrl.perPage = 15;

    $ctrl.search = '';

    $ctrl.$onInit = () => {
        $ctrl.setTableFields();
        $ctrl.getList();
    };

    $ctrl.setTableFields = () => {
        $ctrl.tableFields = $ctrl.selectedFields.filter(v => !! v.pivot.edit_on_directory);
    };

    $ctrl.getList = () => {
        $http
            .get(`/clients/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.total = res.data.total;
                $ctrl.clients = res.data.data;

                $ctrl.clients.forEach(client => {
                    client.fieldValues = {};

                    $ctrl.selectedFields.forEach(field => {
                        if (field.pivot.edit_on_directory) {
                            const fieldValue = client.field_values.find(v => v.field_id === field.id);

                            if (fieldValue) {
                                client.fieldValues[field.id] = fieldValue.value;
                            }

                            if (field.pivot.default_value && !client.fieldValues[field.id]) {
                                client.fieldValues[field.id] = field.pivot.default_value;
                            }
                        }
                    });
                });
            });
    };

    $ctrl.filter = () => {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openForm = (client) => {
        $uibModal.open({
            component: 'clientForm',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                fields() {
                    return $ctrl.selectedFields.filter(v => v.pivot.edit_on_directory);
                },
                client() {
                    return client;
                }
            },
        }).result.then(res => {
            $ctrl.getList();
        });
    };

    $ctrl.delClient = (client, ind) => {
        if (confirm('Вы действительно хотите удалить клиента?')) {
            $http
                .post(`/clients/${client.id}`, {_method: 'DELETE'})
                .then(
                    res => {
                        notifier.successNotify('Успешно удален');
                        $ctrl.clients.splice(ind, 1);
                    },
                    err => {
                        notifier.errorResponseNotify(err);
                    }
                );
        }
    };

    /*
// client.isChecked = $ctrl.selectedClients.findIndex(v => v.id === client.id) !== -1;


    // $ctrl.totalCheck = false;

    // $ctrl.selectedClients = [];

    $ctrl.attachClientsForSelected = () => {
        $uibModal.open({
            component: 'attachFieldToClients',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                fields() {
                    return $ctrl.fields;
                },
                clients() {
                    return $ctrl.selectedClients;
                },
            }
        }).result.finally(() => {
            this.getList();
        });
    };

    $ctrl.totalCheckChanged = () => {
        $ctrl.clients.forEach(client => {
            if (client.isChecked !== $ctrl.totalCheck) {
                client.isChecked = $ctrl.totalCheck;
                $ctrl.itemCheckChanged(client);
            }
        });
    };

    $ctrl.itemCheckChanged = (client) => {
        if (client.isChecked) {
            $ctrl.selectedClients.push(client);
        } else {
            $ctrl.selectedClients = $ctrl.selectedClients.filter(v => v.id !== client.id);
        }
    };
     */
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/clients-control/clients-control.js